var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPassword = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 25,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#888",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "M8 24a7 7 0 1 0 0-14 7 7 0 0 0 0 14"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#888",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "M3 12.11V6c0-2.76 2.24-5 5-5 1.38 0 2.63.56 3.54 1.46C12.44 3.37 13 4.62 13 6v6.11M8 17v2"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#888",
  d: "M8 17.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
})));
export default SvgPassword;